<template>
  <v-app-bar 
    color="secondary"  
    fixed 
    app
    elevate-on-scroll
    style="max-height: 56px;"
  >
    <app-search style="max-height: 50px;"></app-search>
    <v-btn icon to="/searcheroptions">
      <v-icon small>settings</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <app-login-av :auth="auth" style="max-height: 50px;"></app-login-av>
  </v-app-bar>
</template>
<script>
import Loginav from '@/components/Loginav'
import Search from '@/components/Search'

export default {
  name: 'app-header',
  props: {
    auth: Object
  },
  components: {
    'app-login-av': Loginav,
    'app-search': Search
  }
}
</script>
